import Vue from 'vue'
import FloatingVue from 'floating-vue'

Vue.use(FloatingVue, {
  themes: {
    'dropzone-tooltip': {
      $extend: 'tooltip',
      $resetCss: true,
      triggers: ['click'],
      autoHide: true,
      delay: 0
    },
    'support-tooltip': {
      $extend: 'tooltip',
      $resetCss: true,
      delay: 0,
      placement: 'top-end',
      triggers: ['click', 'focus'],
      autoHide: true,
      distance: 12
    },
    'pc-tooltip': {
      $extend: 'tooltip',
      $resetCss: true,
      delay: 0,
      placement: 'bottom-start',
      triggers: ['click', 'focus'],
      autoHide: true,
      distance: 40,
      skidding: -60
    },
    'pc-card': {
      $extend: 'pc-tooltip',
      placement: 'top-start',
      skidding: -90,
      distance: 30,
    },
    'pc-currency-change': {
      $extend: 'pc-tooltip',
      container: 'body',
      placement: 'bottom-end',
      distance: 60,
      strategy: 'absolute',
      shift: true,
      skidding: -50
    }
  }
})
